import * as React from "react"
import { CommandPalette } from "@/components/CommandPalette"
import { MainNav } from "@/components/MainNav"
import { cn } from "@/lib/utils"

export function AppShell({
  children,
  wide = false,
  fullHeight = false,
  topBar,
  nav,
}: {
  children: React.ReactNode
  wide?: boolean
  fullHeight?: boolean
  topBar?: React.ReactNode
  // Replaces the global MainNav rail — the Inbox page renders its own folder
  // rail here per the inbox redesign.
  nav?: React.ReactNode
}) {
  if (fullHeight) {
    return (
      <div className="flex h-dvh overflow-hidden bg-page text-ink-body">
        {nav ?? <MainNav />}
        <CommandPalette />
        <main className="flex h-dvh min-w-0 min-h-0 flex-1 flex-col overflow-hidden">
          {topBar && <div className="shrink-0">{topBar}</div>}
          {children}
        </main>
      </div>
    )
  }

  return (
    <div className="flex min-h-screen bg-page text-ink-body">
      <MainNav />
      <CommandPalette />
      <main className="min-w-0 flex-1 px-6 py-8 sm:px-10">
        <div className={cn("mx-auto", wide ? "max-w-7xl" : "max-w-4xl")}>
          {children}
        </div>
      </main>
    </div>
  )
}
